import { useContext } from "react";
import MetadataCircuitsContext from "../contexts/MetadataCircuitsContext";

/**
 * Returns the scored circuits available to dashboard measure pickers. Excludes
 * no-input circuits (see {@link MetadataProvider}). Falls back to an empty array
 * when used outside the provider, so circuits are an additive concern.
 */
function useMetadataCircuits() {
  return useContext(MetadataCircuitsContext);
}

export default useMetadataCircuits;
